import { render } from "./ContentCard.vue?vue&type=template&id=6e1f301c&ts=true"
import script from "./ContentCard.vue?vue&type=script&lang=ts"
export * from "./ContentCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__